module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/how-to-enjoy-sola-02-946a98ca11cb124e39c2413f7045fc4a.jpg";